import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-call-bridge-schema'
import config from './req.config'

export type { paths as CallBridgePaths }

export const callBridgeReq = createFetchClient<paths>({
  ...config,
})

export const callBridgeQuery = createClient<paths>(callBridgeReq)
